// CostToast — transient bottom-right notification fired after each
// generation completes. Auto-dismisses after 5 seconds; user can
// manually dismiss by tapping. Does NOT block any UI.

import { useEffect } from 'react';

import { formatUsd, useCost } from '../state/cost';

const AUTO_DISMISS_MS = 5_000;

export function CostToast() {
  const lastTurn = useCost((s) => s.lastTurn);
  const clearLastTurn = useCost((s) => s.clearLastTurn);

  useEffect(() => {
    if (!lastTurn) return;
    const t = setTimeout(() => clearLastTurn(), AUTO_DISMISS_MS);
    return () => clearTimeout(t);
  }, [lastTurn, clearLastTurn]);

  if (!lastTurn) return null;

  return (
    <div
      className="pointer-events-auto fixed bottom-5 right-5 z-40 max-w-[320px] rounded-md border border-emerald-900/60 bg-[#0d0d12]/95 p-3 text-[11.5px] shadow-2xl backdrop-blur-sm"
      role="status"
      aria-live="polite"
    >
      <div className="flex items-start justify-between gap-3">
        <div className="flex-1">
          <div className="font-semibold tracking-tight text-emerald-200">
            ✓ 用咗 {formatUsd(lastTurn.usd)}
          </div>
          <div className="mt-0.5 text-[10.5px] text-neutral-500 tabular-nums">
            {lastTurn.model} · {lastTurn.tokens.toLocaleString()} tokens
            <span className="ml-1 text-neutral-700">
              ({lastTurn.inputTokens.toLocaleString()} in /{' '}
              {lastTurn.outputTokens.toLocaleString()} out)
            </span>
          </div>
        </div>
        <button
          type="button"
          onClick={clearLastTurn}
          className="text-[14px] leading-none text-neutral-600 hover:text-neutral-300"
          aria-label="關閉"
        >
          ✕
        </button>
      </div>
    </div>
  );
}
